import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { TipoPrograma } from '../__enum';

export const useHabilitaCampoPrograma = (tipoPrograma: TipoPrograma) => {
    const programas = useSelector((state: RootState) => state.escolas.programas);

    const isDesabilitado = useMemo(() => {
        const programa = programas?.[tipoPrograma];
        return programa?.ativo === false;
    }, [programas, tipoPrograma]);

    const classeCondicional = isDesabilitado ? 'campo-desabilitado' : '';

    return { isDesabilitado, classeCondicional };
};
